import { AdvancedAssignmentFilterOption } from 'api/model';

/**
 * "Visa mellanlandade bilar på alla ärendetyper" sparas mellan sessioner, till skillnad från
 * övriga uppdragsfilter.
 *
 * Skälet: mellanlandade ben (PlannedFurtherTransport) visas som standard bara på hemleveranser,
 * där en delad leverans är ett stafettbyte som trafikledningen behöver se båda benen av, och på
 * butiksleveranser, där TL lägger till vidaretransporten för hand. Den som
 * vill se dem på alla ärendetyper ska slippa kryssa i rutan varje gång sidan laddas om.
 *
 * Bara den här flaggan persisteras. Att spara alla avancerade filter hade fått varenda kryssruta
 * att sitta kvar mellan sessioner, vilket ingen har bett om och som är lätt att bli förvånad av.
 */
const STORAGE_KEY = 'assignmentsFilters.includeAllStopovers';

/** Privat läge i webbläsaren, blockerad site-data och liknande får aldrig fälla filterpanelen. */
const readFlag = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

const writeFlag = (enabled: boolean): void => {
  try {
    if (enabled) {
      localStorage.setItem(STORAGE_KEY, 'true');
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    /* Går det inte att spara får växeln gälla den här sessionen. */
  }
};

/** Filtren som ska gälla vid sidladdning: tomt, eller enbart den sparade växeln. */
export const getPersistedAdvancedFilters =
  (): Set<AdvancedAssignmentFilterOption> | null =>
    readFlag()
      ? new Set([AdvancedAssignmentFilterOption.IncludeAllStopovers])
      : null;

/** Anropas när filtren ändras, så att växeln överlever en omladdning. */
export const persistStopoverFilter = (
  advancedFilters: Set<AdvancedAssignmentFilterOption> | null
): void =>
  writeFlag(
    advancedFilters?.has(AdvancedAssignmentFilterOption.IncludeAllStopovers) ??
      false
  );
